import { useHistory } from 'react-router';
import { Box, IconButton } from '@chakra-ui/react';
import moment from 'moment';

import { TableColumn } from '@app/components/common/table';
import { Txt } from '@app/components/common'; 
import { Delivery } from '@app/api/socket-service';

import { getDeliveryEntityID, getDeliveryName, getDeliveryStatus } from './utils/getDeliveryName';


// eslint-disable-next-line import/no-anonymous-default-export
export const useColumns = (): TableColumn<Delivery>[] => {
  return [
    {
      name: 'id',
      label: '#',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'userDevice',
      label: 'Пользователь',
      options: {
        filter: {
          type: 'text',
          name: 'username',
        },
        sort: true,
        customBodyRender: (userDevice: string) => <Txt color="gray.500">{userDevice.split('-')[0]}</Txt>,  
      },
    },
    {
      name: 'key',
      label: 'Данные',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (key: string, { rowData }) => {
          const typePrefix = key.slice(0, 2);
          return (
            <>
              <Txt color="brand.500" style={{ fontSize: 16 }}>
                {getDeliveryName(key)}
              </Txt>
              <Box display="flex">
                <Txt color="gray.500">{getDeliveryEntityID(rowData.key)}:&nbsp;</Txt>
                <Txt color="primary">{key.split('_')[1]}</Txt>
              </Box>
            </>
          );
        },
      },
    },
    {
      name: 'createdTimestamp',
      label: 'Создан',
      options: {
        filter: {
          name: 'createdTimestamp',
          type: 'date-range',
          onApply: (value) => value + 'T00:00:00',
        },
        sort: true,
        customBodyRender: (timestamp: number) => <Txt color="gray.500">{moment(timestamp).format('DD.MM.YYYY HH:mm')}</Txt>,
      },
    },
    {
      name: 'receivedTimestamp',
      label: 'Получен',
      options: {
        filter: {
          name: 'receivedTimestamp',
          type: 'date-range',
          onApply: (value) => value + 'T00:00:00',
        },
        sort: true,
        customBodyRender: (timestamp: number) => <Txt color="gray.500">{moment(timestamp / 1000).format('DD.MM.YYYY HH:mm')}</Txt>,
      },
    },
    {
      name: 'sentTimestamp',
      label: 'Отправлен',
      options: {
        filter: {
          name: 'sentTimestamp',
          type: 'date-range',
          onApply: (value) => value + 'T00:00:00',
        },
        sort: true,
        customBodyRender: (timestamp: number) => <Txt color="gray.500">{moment(timestamp / 1000).format('DD.MM.YYYY HH:mm')}</Txt>,
      },
    },
    {
      name: 'status',
      label: 'Статус',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (status: string) => <Txt color="gray.500">{getDeliveryStatus(status)}</Txt>,
      },
    },
    {
      name: 'response',
      label: 'Ответ',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (response: { String: string, Valid: boolean }, { rowData }) => {
          if (rowData.status === '_error') {
            return <Txt color="red.500">{rowData.parseError.String || rowData.transferError.String || rowData.response.String}</Txt>;
          }
          return <Txt color="brand.500">{response.String}</Txt>;
        },
      },
    },
  ];
};
